<template>
    <div class="select-week-day">
        <DesignedSelectOne :id="name" :name="name" :items="items" v-model="internalValue"
                           :item-label="itemLabel" item-value="value" :empty-value="false"
                           :rules="rules" :label="label" :width="width" :dropdown-class="dropdownClass"
        />
    </div>
</template>

<script>
    import DesignedSelectOne from "../inner/DesignedSelectOne";
    import {DateUtils} from "@/utils/DateUtils";

    export default {
        name: "DesignedSelectWeekDay",

        props: {
            dropdownClass: {
                type: String,
                default: null,
            },
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            icon: {
                type: String,
            },
            width: {
                type: String,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            itemLabel: {
                type: String,
                default: "labelPlural",
            },
            rules: undefined,
            modelValue: null,
        },

        emits: ["update:modelValue"],

        data() {
            return {
                items: DateUtils.daysOfTheWeek,
            };
        },

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },

            computedClasses() {
                return this.errorMessage ? "p-invalid" : "";
            },
        },

        components: {DesignedSelectOne},
    };
</script>

<style lang="less" scoped>
    .select-organization {
        label {
            display: none;
        }
    }
</style>
